export const hide = (value) => {
  return !!value ? 'visibility-hidden' : '';
}

export const makeTranslucent = (value) => {
  return !!value ? 'translucent' : '';
}
